import type { Chart } from 'highcharts';
import type { PointStateValue } from 'highcharts/highstock';

export const getSeriesWeight = (ratio: number, totalAmount: number, categoryAmount: number, netAmount: number) =>
    netAmount > 0 ? categoryAmount / totalAmount : ratio;

/**
 * Sets the state of all items in the legend except the one with the given name.
 * following source code from HighChart: https://github.com/highcharts/highcharts/blob/master/ts/Core/Legend/Legend.ts#L1579
 * @param chart
 * @param state
 * @param name
 */
export const setOtherItemsState = (chart: Chart, state: PointStateValue, name?: string): void => {
    chart?.legend?.allItems.forEach((item): void => {
        if (item.name !== name) {
            [item].concat((item as any).linkedSeries || []).forEach((otherItem): void => {
                otherItem.setState(state, true);
            });
        }
    });
};
